// extracted by mini-css-extract-plugin
export default {"title":"title__ZWveM","content":"content__XSZ-4","carousel":"carousel__boeqt","link":"link__0lCA7","quotes-header":"quotes-header__cyLxi"};